<template>
  <!-- BEGIN HEADER -->
  <div class="header">
    <!-- MOBILE -->
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-subheader class="text-uppercase font-weight-bold my-2">
        <router-link v-if="logoPath.length" to="/">
          <img :src="logoPath" alt="logo" max-height="70">
        </router-link>
        <router-link v-else to="/">
          <h2>{{ resellerCustomName }}</h2>
        </router-link>
      </v-subheader>
      <v-list dense nav>
        <template v-for="(item, index) in modifiedMenu">
          <v-list-item v-if="item.childPages.length < 1" :key="index" :to="item.link">
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :key="index"
            ref="group"
            v-model="expandedItems[index]"
          >
            <template v-slot:activator>
              <v-list-item-title>
                <div class="group-title" @click="groupTitleClicked(item)">
                  {{ item.title }}
                </div>
              </v-list-item-title>
            </template>
            <v-list-item
              v-for="(childItem, childIndex) in item.childPages"
              :key="childIndex"
              :to="childItem.link"
            >
              <v-list-item-title class="ml-2">{{ childItem.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    
    <v-btn class="d-md-none drawer-button" rounded @click="drawer = !drawer">
      <v-icon right>mdi-menu</v-icon>
    </v-btn>

    <!-- DESKTOP (TOP NAV) -->
    <v-app-bar app height="80" class="mx-14">
      <v-container class="py-0 px-0 fill-height container--fluid " :fluid="true">
        <router-link v-if="logoPath.length" to="/" class="d-flex align-left text-decoration-none">
          <img :src="logoPath" alt="logo" max-height="70">
        </router-link>
        <router-link v-else to="/" class="d-flex align-left text-decoration-none">
          <h2>{{ resellerCustomName }}</h2>
        </router-link>
        <v-spacer></v-spacer>
        <div class="d-none d-md-block">
          <template v-for="(item, index) in modifiedMenu">
            <v-btn
              v-if="item.childPages.length < 1"
              :key="index"
              text
              :to="item.link"
              class="body-1"
            >
              {{ item.title }}
            </v-btn>
            <v-menu
              v-else
              :key="index"
              open-on-hover
              offset-y
              attach
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  text
                  v-bind="attrs"
                  class="body-1"
                  :to="item.link"
                  v-on="on"
                >
                  {{ item.title }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(childItem, childIndex) in item.childPages" :key="childIndex" :to="childItem.link">
                  <v-list-item-title class="body-1">{{ childItem.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </div>
      </v-container>
    </v-app-bar>
  </div>
  <!-- END HEADER -->
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    isFluid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawer: null,
      expandedItems: {}  // This property is needed for the v-list-group v-model binding
    }
  },
  computed: {
    ...mapGetters({
      menu: 'microsite/menu'
    }),
    modifiedMenu() {
      const menuItems = this.menu.map((item) => {
          // Ensure childPages is an array and filter out any invalid child pages
          const validChildPages = Array.isArray(item.childPages)
            ? item.childPages.filter((child) =>
                child && typeof child.title === 'string' && child.title.trim().length &&
                child.link && typeof child.link === 'string' && child.link.trim().length
              )
            : []
            
          return {
            ...item,
            childPages: validChildPages
          }
        })

      if (this.meta.attributes?.PublicManage === 'true') {
        menuItems.push({ Id: -1, link: '/manage-coverage', title: 'Manage Coverage', childPages: [] })
      }

      if (this.meta.attributes?.PublicOrders === 'true') {
        menuItems.push({ Id: -1, link: '/order', title: 'Get Quote', childPages: [] })
      }

      return menuItems
    },
    ...mapState({
      meta: (state) => state.microsite.meta
    }),
    logoPath() {
      if (this.meta.custom_logo.length)
        return `/${process.env.VUE_APP_DEFAULT_MICROSITE_PUBLIC_FOLDER}/${this.meta.custom_logo}`
      else return ''
    },
    resellerCustomName() {
      return this.meta.custom_name
    }
  },
  watch: {
    drawer() {
      if (!this.drawer && this.$refs.group) {
        this.$refs.group.forEach((group) => {
          if (group) group.isActive = false
        })
      }
    }
  },
  methods: {
    groupTitleClicked(linkObj) {
      if (this.$route.path !== linkObj.link) {
        this.$router.push(linkObj.link)
      }
    }
  }
}
</script>

<style scoped>
.drawer-button {
  position: fixed;
  top: 60px;
  left: 10px; /* Adjusted for visibility */
  z-index: 6;
}

.group-title {
  width: 100%;
  height: 32px;
  padding: 8px 0;
}

/* Fix menu overflow issues */
.v-application {
  overflow: visible !important;
}
.v-menu__content {
  overflow: visible !important;
  position: absolute !important;
  z-index: 1000 !important;
}
.v-list-item__title,
.v-list-item__content,
.v-list-item {
  font-family: "Heebo", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  text-transform: none !important;
}
</style>
